(function (widgets) {
  const AIChat = widgets.Widget.extend(
    {
      constructor: function AIChatConstructor(object) {
        // For Opt-in view.
        const consent = object['passthru'][`${object.id}-consent_given`];
        object['consent_given'] =
          typeof consent === 'string' ? consent === 'true' : consent; // default (null)

        AIChat.__super__.constructor.call(this, object);
      },
      render: function () {
        let self = this;
        AIChat.__super__.render.call(this);

        // Hide the default navigation
        mainNav.hide();

        // Auto advance if "finished" already
        if (this._object.finished) {
          setTimeout(function () {
            click_next({ key: '', type: 'click' });
          }, 8000);
        }

        // Consent view shown (null or false)
        if (
          this._object.consent_given === null ||
          !this._object.consent_given
        ) {
          this.continueBtn = document.getElementById('continue_button');
          this.skipBtn = document.getElementById('skip_button');
          this.consentInput = document.getElementsByName(
            `${this._object.id}-consent_given`
          );

          // Event Handlers
          this.handleContinue = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            // Update hidden fields
            self._setAction('agree');
            if (self.consentInput && self.consentInput.length > 0)
              self.consentInput[0].value = true;

            click_next({ key: '', type: 'click' });
          };
          this.handleSkip = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            // Update hidden fields
            self._setAction('disagree');
            if (self.consentInput && self.consentInput.length > 0)
              self.consentInput[0].value = false;

            click_next({ key: '', type: 'click' });
          };

          // Event Listeners
          this.continueBtn.addEventListener('click', this.handleContinue); // mouse
          this.skipBtn.addEventListener('click', this.handleSkip); // mouse

          this.continueBtn.addEventListener('keypress', this.handleContinue); // keyboard (a11y)
          this.skipBtn.addEventListener('keypress', this.handleSkip); // keyboard (a11y)

          return;
        }

        // If consent is given, initialize the rest of the widget.
        if (this._object.consent_given) {
          this.userResponse = document.getElementById(
            'r-' + this._object.input_id
          );
          this.submitBtn = document.getElementById('ai-submit');

          this.submit = function (event) {
            if (event.type === 'keypress' && event.key !== 'Enter') return;

            event.preventDefault();
            event.stopImmediatePropagation();

            // Update hidden field
            self._setAction('continue');

            // Disable form field and button
            self.userResponse.disabled = true;
            self.submitBtn.disabled = true;

            // Loading state for the Send button
            $(self.submitBtn).addClass('loading-button');

            click_next({ key: '', type: 'click' });
          };

          // Event handlers
          this.userResponse.addEventListener('keypress', this.submit);
          this.submitBtn.addEventListener('click', this.submit);
        }
      },
      destroy: function destroy() {
        try {
          if (
            this.continueBtn &&
            this.skipBtn &&
            this.handleContinue &&
            this.handleSkip
          ) {
            this.continueBtn.removeEventListener('click', this.handleContinue);
            this.continueBtn.removeEventListener(
              'keypress',
              this.handleContinue
            );

            this.skipBtn.removeEventListener('click', this.handleSkip);
            this.skipBtn.removeEventListener('keypress', this.handleSkip);
          }

          if (this.userResponse && this.submitBtn && this.submit) {
            this.userResponse.removeEventListener('keypress', this.submit);
            this.submitBtn.removeEventListener('click', this.submit);
          }
        } catch (error) {}
      },
      _setAction: function _setAction(action) {
        /**
         * Expected values (tentative):
         * - agree
         * - disagree
         * - continue
         * - end
         * - report
         */
        let self = this;

        if (action) {
          self.actionInput = document.getElementsByName(
            `${self._object.id}-action`
          );

          // Set the form field based on the action
          if (self.actionInput && self.actionInput.length > 0)
            self.actionInput[0].value = action;
        }
      },
    },
    {
      types: ['ai-chat'],
      views: ['ai-chat'],
    }
  );

  AIChat.register();
  widgets.AIChat = AIChat;
})((Gryphon.widgets = Gryphon.widgets || {}));
